import { Skeleton, Spacer } from '@heroui/react';
import { Container } from '@school-manage/ui/Container/Container';
import { HeaderBar } from '@school-manage/ui/HeaderBar/HeaderBar';
import { useTranslation } from 'react-i18next';

export function EditProfileSkeleton() {
  const { t } = useTranslation();

  return (
    <>
      <HeaderBar title={t('changePassword')} />
      <Container>
        <div className="flex flex-col justify-center p-[16px]">
          <Skeleton className="h-9 w-full rounded-lg" />
          <Spacer y={4} />
          <Skeleton className="h-9 w-full rounded-lg" />
          <Spacer y={4} />
          <Skeleton className="h-9 w-full rounded-lg" />

          <div className="my-4 flex flex-col gap-y-2">
            <Skeleton className="h-6 w-3/4 rounded-lg" />
            <Skeleton className="h-6 w-3/4 rounded-lg" />
            <Skeleton className="h-6 w-3/4 rounded-lg" />
          </div>

          <div className="mb-12 mt-4">
            <Skeleton className="h-10 w-full rounded-lg" />
          </div>
        </div>
      </Container>
    </>
  );
}
